<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Accueil</router-link></li>
        <li
          class="breadcrumb-item active"
          aria-current="page">Nouveau contrat</li>
      </ol>
    </nav>
    <b-form @submit="onSubmit">
      <b-card-group deck>
        <b-card
          header="1. Paramétrez l'offre"
          header-tag="header">
          <b-card-group
            deck
            class="home-card">
            <b-container>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-offer"
                    label="Type d'offre"
                    label-for="input-offer">
                    <b-form-select
                      id="input-offer"
                      v-model="form.cont_off_id"
                      :options="offersInForm"
                      required
                    />
                  </b-form-group>
                </b-col>
                <b-col class="marginable">
                  <b-form-checkbox
                    id="input-is-project"
                    v-model="form.cont_is_project"
                    :value="true"
                    :unchecked-value="false"
                  >
                    Mode projet <font-awesome-icon
                      id="tooltip-mode-project"
                      :icon="['fas', 'info-circle']" />
                  </b-form-checkbox>
                  <b-tooltip
                    target="tooltip-mode-project"
                    triggers="hover">
                    Cela peut concerner n'importe quelle offre. On devra spécifier une date de fin.
                  </b-tooltip>
                </b-col>
              </b-row>
              <b-row v-if="form.cont_off_id === 1">
                <div class="info-danger">
                  Choisir une offre groupe vous obligera à paramétrer une liste de modules autorisés.
                  <br>
                  {{ "Cela ne concerne que les groupes ayant des demandes spécifiques " +
                  "(date de déploiement, modules particuliers...)" }}
                </div>
                <b-form-group
                  id="input-group-offer-group-name"
                  label="Nom du groupe (exemple : COLISEE, ORPEA, ...)"
                  label-for="input-offer-group-name">
                  <b-form-input
                    id="input-internal-name"
                    v-model="form.offer_group_name"
                    type="text"
                    required
                  />
                </b-form-group>
              </b-row>
            </b-container>

          </b-card-group>
        </b-card>
        <b-card
          header="2. Paramétrez les dates"
          header-tag="header">
          <b-card-group
            deck
            class="home-card">
            <b-container>
              <b-form-group>
                <label class="d-block">Date de début <font-awesome-icon
                  id="tooltip-date-start"
                  :icon="['fas', 'info-circle']" /></label>
                <b-tooltip
                  target="tooltip-date-start"
                  triggers="hover">
                  Date de la formation
                </b-tooltip>
                <b-form-input
                  id="input-date-start"
                  v-model="form.cont_date_start"
                  type="date"
                  required
                />
              </b-form-group>
              <b-form-group
                v-if="form.cont_is_project"
                id="input-group-date-end"
                label="Date de fin"
                label-for="input-date-end">
                <b-form-input
                  id="input-date-end"
                  v-model="form.cont_date_end"
                  type="date"
                  required
                />
              </b-form-group>
            </b-container>
          </b-card-group>
        </b-card>
      </b-card-group>
      <b-card-group deck>
        <b-card
          header="3. Paramétrez les montants"
          header-tag="header">
          <b-card-group
            deck
            class="home-card">
            <b-container>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-subscription-amount"
                    label="Montant de l'abonnement"
                    label-for="input-subscription-amount">
                    <b-form-input
                      id="input-subscription-amount"
                      v-model="form.cont_subscription_amount"
                      type="number"
                      step="any"
                      required
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-formation-amount"
                    label="Montant de la formation"
                    label-for="input-formation-amount">
                    <b-form-input
                      id="input-formation-amount"
                      v-model="form.cont_formation_amount"
                      type="number"
                      step="any"
                      required
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-material-amount"
                    label="Montant du matériel"
                    label-for="input-material-amount">
                    <b-form-input
                      id="input-material-amount"
                      v-model="form.cont_material_amount"
                      type="number"
                      step="any"
                      required
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-card-group>
        </b-card>
        <b-card
          header="4. Paramétrez les autres informations"
          header-tag="header">
          <b-card-group
            deck
            class="home-card">
            <b-container>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-comment"
                    label="Commentaires"
                    label-for="input-comment">
                    <b-form-textarea
                      id="textarea"
                      v-model="form.cont_comment"
                      placeholder=""
                      rows="3"
                      max-rows="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="marginable">
                  <b-form-checkbox
                    id="input-is-group"
                    v-model="form.is_group"
                    :value="true"
                    :unchecked-value="false"
                  >
                    Ce contrat concerne un groupement d'établissements <font-awesome-icon
                      id="tooltip-mode-group"
                      :icon="['fas', 'info-circle']" />
                  </b-form-checkbox>
                  <b-tooltip
                    target="tooltip-mode-group"
                    triggers="hover">
                    Cela signifie qu'il y aura un établissement parent.
                  </b-tooltip>
                </b-col>
                <b-col v-if="form.is_group">
                  <b-form-group
                    id="input-group-group-name"
                    label="Nom du groupement (exemple : GCSMS, GERONTONUM, COLISEE, ...)"
                    label-for="input-group-name">
                    <b-form-input
                      id="input-internal-name"
                      v-model="form.group_name"
                      type="text"
                      required
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-card-group>
        </b-card>
      </b-card-group>
      <b-container>
        <b-row>
          <b-col>
            <b-button
              type="submit"
              variant="primary">Enregistrer</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-form>

  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import router from '../router';
import FormEstablishment from '../components/forms/FormEstablishment.vue';

const moment = require('moment');

export default {
  components: {
    FormEstablishment,
  },
  data() {
    return {
      form: {
        cont_date_start: moment().format('YYYY-MM-DD'),
        cont_date_end: null,
        cont_off_id: null,
        cont_off_name: null,
        cont_subscription_amount: null,
        cont_formation_amount: null,
        cont_material_amount: null,
        cont_comment: null,
        cont_is_project: false,
        offer_group_name: null,
        is_group: false,
        group_name: null,
        establishments: [],
      },
      offersInForm: [],
      linkEstablishments: [],
      newEstablishment: null,
      unassociatedEstablishmentsInForm: [],
    };
  },
  computed: mapState({
    offers: state => state.contracts.offers,
    unassociatedEstablishments: state => state.establishments.unassociated,
  }),
  mounted() {
    this.populateView();
    this.updateStore();
  },
  methods: {
    populateView() {
      this.mapOffers();
      this.mapEstablishments();
    },
    updateStore() {
      this.$store.dispatch('contracts/getAllOffers')
        .then(() => this.mapOffers())
        .catch(err => console.log(err));
      this.$store.dispatch('establishments/getUnassociatedEstablishments')
        .then(() => this.mapEstablishments())
        .catch(err => console.log(err));
    },
    establishmentChange() {
      for (let i = 0; i < this.unassociatedEstablishmentsInForm.length; i += 1) {
        console.log(this.unassociatedEstablishmentsInForm[i]);
        if (this.unassociatedEstablishmentsInForm[i].value === this.newEstablishment) {
          this.form.establishments.push({
            esta_id: this.newEstablishment,
            esta_name: this.unassociatedEstablishmentsInForm[i].text,
          });
          break;
        }
      }
    },
    makeToast(type, message) {
      this.$bvToast.toast(message, {
        noCloseButton: true,
        variant: type,
        autoHideDelay: 5000,
      });
    },
    removeEstablishment(estaId) {
      for (let i = 0; i < this.form.establishments.length; i += 1) {
        if (this.form.establishments[i].esta_id === estaId) {
          this.form.establishments.splice(i, 1);
          break;
        }
      }
    },
    mapOffers() {
      try {
        const json = JSON.parse(JSON.stringify(this.offers.filter(e => e.off_relative_to_id === null)));
        this.offersInForm = [];
        for (let i = 0; i < json.length; i += 1) {
          this.offersInForm.push({ value: json[i].off_id, text: json[i].off_name });
        }
      } catch (e) {
        console.log(e);
      }
    },
    mapEstablishments() {
      try {
        const json = JSON.parse(JSON.stringify(this.unassociatedEstablishments));
        this.unassociatedEstablishmentsInForm = [];
        for (let i = 0; i < json.length; i += 1) {
          this.unassociatedEstablishmentsInForm.push({ value: json[i].esta_id, text: json[i].esta_name });
        }
      } catch (e) {
        console.log(e);
      }
    },
    addEstablishment(data) {
      console.log(`Add establishment: ${JSON.stringify(data)}`);
      this.form.establishments.push({
        esta_id: data.esta_id,
        esta_name: data.esta_name,
      });
    },
    handleSubmitResult(data) {
      router.push({ name: 'ContractDetails', params: { id: data.cont_id } });
    },
    onSubmit(evt) {
      evt.preventDefault();
      // this.form.establishments = this.linkEstablishments
      for (let i = 0; i < this.form.establishments.length; i += 1) {
        this.linkEstablishments.push(parseInt(this.form.establishments[i].esta_id, 10));
      }
      this.form.establishments = this.linkEstablishments;
      this.form.cont_misc = { comment: this.form.cont_comment };
      delete this.form.cont_comment;
      console.log(JSON.stringify(this.form));
      this.$store.dispatch('contracts/addContract', this.form)
        .then(response => (this.handleSubmitResult(response.data)))
        .catch(error => (this.makeToast('danger', error)));
    },
    receiveForm(formEstablishment) {
      console.log(formEstablishment);
      this.$root.$emit('bv::hide::modal', 'modal-establishment');
      this.$store.dispatch('establishments/addEstablishment', formEstablishment)
        .then(response => (this.addEstablishment(response.data)))
        .catch(error => (this.makeToast('danger', error)));
    },
  },
};
</script>
<style>
  .marginable {
    margin-top: 35px;
  }
  .info-danger {
    text-align: justify;
    margin: 15px;
    color: red;
    font-weight: bold;
    font-size: 14px;
    font-style: italic;
  }
  #input-group-offer-group-name {
    padding: 15px;
    text-align: center;
    margin: auto;
  }
  .home-card {
    padding: 0 15px;
  }
</style>
